import { Loader2 } from "lucide-react";
import { cn } from "../lib/utils";

/** Shared loading state for lists; use inside a cell when rendered in a table. */
export default function ListLoading({ label = "Einträge werden geladen …", compact = false, className }) {
  return (
    <div role="status" aria-live="polite" className={cn(
      "flex flex-col items-center justify-center gap-3 rounded-xl bg-[#F5F5F7] text-[#1D1D1F]",
      compact ? "min-h-[96px] px-3 py-4" : "min-h-[160px] px-4 py-8",
      className,
    )}>
      <span className="motion-safe:animate-spin"><Loader2 className="h-8 w-8" aria-hidden="true" /></span>
      <span className="text-center text-sm font-medium">{label}</span>
    </div>
  );
}
